import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import isEmpty from 'ramda/src/isEmpty';
import slice from 'ramda/src/slice';
import Button from '@components/@core/AnimatedButton';
import Pagination from '@components/@core/Pagination';
import CommunityActions from '~/actions/community';
import EmptyBlog from './EmptyBlog';
import BlogItem from './BlogItem';
import { getHtmlImages } from '~/services/util';

const VendorSearchBlogs = ({ data, type, onPage, onSeeAll }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const blogList = data?.data ?? [];
    const blogs = type === 'sub' ? slice(0, 3, blogList) : blogList;

    const handleOpenDetail = (e) => () => {
        window.location = e?.data?.permalink;
        {
            /*
    const { id, data, user_id } = e
    dispatch(CommunityActions.getcommunityuserRequest({ userId: user_id, blogId: data?.blog_id }))
    dispatch(
      CommunityActions.getblogdetailsRequest(user_id, { blogId: data?.blog_id, perPage: 100 })
    )
    navigate({
      pathname: e?.data?.permalink,
      state: { post: e },
    })
    */
        }
    };

    return (
        <div className="vendor-search-blogs">
            <div className="d-h-between">
                <div className="d-h-start">
                    <p className="dsl-b18 bold me-2">Blogs</p>
                    <p className="dsl-p12">{`(${data?.total ?? blogList.length})`}</p>
                </div>
            </div>
            {isEmpty(blogs) ? (
                <EmptyBlog />
            ) : (
                <div className="pb-3 mb-5">
                    {blogs.map((blog) => {
                        const { id, author, name, body_text, stats, updated_at, data, comments } = blog;
                        return (
                            <BlogItem
                                key={`blog-${id}`}
                                name={name}
                                author={author}
                                description={body_text}
                                thumb={getHtmlImages(data.body)[0]}
                                stats={stats}
                                comments={comments}
                                createAt={updated_at}
                                type={type === 'sub' ? 'simple' : 'detail'}
                                onClick={handleOpenDetail(blog)}
                            />
                        );
                    })}
                    {type === 'sub' ? (
                        <div className="d-h-end">
                            <Button type="link" name="SEE ALL" onClick={onSeeAll} />
                        </div>
                    ) : (
                        <Pagination current={data?.current_page ?? 1} pers={data?.per_page} total={data?.last_page ?? 0} onChange={onPage} />
                    )}
                </div>
            )}
        </div>
    );
};

VendorSearchBlogs.propTypes = {
    data: PropTypes.shape({
        data: PropTypes.array,
    }),
    type: PropTypes.oneOf(['sub', 'full']),
    onSeeAll: PropTypes.func,
    onPage: PropTypes.func,
};

VendorSearchBlogs.defaultProps = {
    data: { data: [] },
    type: 'sub',
    onSeeAll: () => {},
    onPage: () => {},
};

export default memo(VendorSearchBlogs);
